import React, {Component, ReactElement} from 'react'
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    MainContainer,
    ParagraphText,
} from '../../../styledComponents/ContentsArea'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {DisplayBlockDiv} from '../../../styledComponents/DisplayItem'
import {SecondaryButton} from '../../../styledComponents/Button'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
}

class NatResidentChangeMailAddressMailSendPage extends Component<Props & ResidentPagePropsSet> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)

        this.backUserSettingButtonClick = this.backUserSettingButtonClick.bind(this)
    }

    // 個人設定のページへ戻る
    backUserSettingButtonClick(): void {
        this.props.navigate(
            `/resident/personalSetting`,
        )
    };

    render(): ReactElement {
        return (
            <>
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        変更確認メールを送信
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <MainContainer>
                    <MessageBlock>
                        <Message>
                            送信したメールに記載された、リンク先URLを表示してください。<br/>
                            ※変更前のメールアドレスでログインしていないと変更手続きは完了いたしません。<br/>
                        </Message>
                    </MessageBlock>
                    <DisplayBlockDiv>
                        <SecondaryButton
                            onClick={this.backUserSettingButtonClick}>個人設定のページへ戻る</SecondaryButton>
                    </DisplayBlockDiv>
                </MainContainer>
            </>
        )
    }
}

export default createResidentPage(NatResidentChangeMailAddressMailSendPage)

// メッセージブロック
const MessageBlock: StyledDiv = styled.div`
  text-align: center;
`
// メッセージ
const Message = styled(ParagraphText)`
  display: inline-block;
  text-align: left;
`
